import { useQuery } from '@tanstack/react-query'
import getSearch from '../next-api/search'

export const useSearch = (searchParam: string) => {
  return useQuery({
    queryKey: ['search', searchParam],
    queryFn: () => getSearch(searchParam),
    enabled: searchParam.length > 2,
  })
}
